import React from 'react';
import { Link } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';
import uniqueId from 'lodash/uniqueId';
import './styles.css';


const Button = ({
  to, type, children, className, tooltipText, ...props
}) => {
  const buttonId = uniqueId();
  if (to) {
    return (
      <Link
        styleName={className && className !== '' ? className : 'btn'}
        to={to}
        data-tip={tooltipText}
        data-for={buttonId}
        {...props}
      >
        {children}
        {
          tooltipText ? <ReactTooltip
            place="bottom"
            styleName="tooltipTheme"
            id={buttonId}
            effect="solid"
            globalEventOff="click"
          /> : null
        }
      </Link>
    );
  }
  return (
    <button
      styleName={className && className !== '' ? className : 'btn'}
      type={type}
      data-tip={tooltipText}
      data-for={buttonId}
      {...props}
    >
      {children}
      {
          tooltipText ? <ReactTooltip
            styleName="tooltipTheme"
            id={buttonId}
            effect="solid"
            globalEventOff="click"
          /> : null
        }
    </button>
  );
};


export default Button;



// WEBPACK FOOTER //
// ./src/components/Button/TooltipButton.js